/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Fragment } from 'react';
import ImageZoom from 'react-medium-image-zoom';
import { Map } from 'immutable';
import { Modifier, EditorState } from 'draft-js';

import { DOC_WIDTH } from '../utilities/CONSTANTS';
import { withEditorState } from './EditorStateContext';

const RADIX_BASE_10 = 10;

class Image extends React.PureComponent {
    getStyles = () => {
        const { editorState, block } = this.props;
        const contentState = editorState.getCurrentContent();
        return contentState.getBlockForKey(block.key).getData().toJS() || {};
    };

    handleImageLoaded = (e) => {
        const {
            block,
            editorState,
            setEditorState,
            isPlaceholder,
        } = this.props;
        const blockKey = block.getKey();
        const content = editorState.getCurrentContent();
        const styles = this.getStyles();

        if (Object.keys(styles).length === 0 && isPlaceholder !== true) {
            let { naturalWidth: width, naturalHeight: height } = e.target;

            if (width > DOC_WIDTH) {
                const ratio = DOC_WIDTH / width;
                width = parseInt(width, RADIX_BASE_10) * ratio;
                height = parseInt(height, RADIX_BASE_10) * ratio;
            }

            setEditorState(
                EditorState.push(
                    editorState,
                    Modifier.setBlockData(
                        content,
                        editorState.getSelection().merge({
                            anchorKey: blockKey,
                            focusKey: blockKey,
                            anchorOffset: 0,
                            focusOffset: 0,
                        }),
                        Map({
                            width,
                            height,
                        }),
                    ),
                ),
            );
        }
    };

    render() {
        const {
            src,
            readOnly,
            alt,
            entityData,
        } = this.props;
        const {
            isExternalPastedImage, isBase64Image, errorUploading, externalUploadedImage,
        } = entityData;

        const defaultStyles = { overlay: { background: 'rgba(0, 0, 0, 0.5)' } };

        if (readOnly) {
            return (
                <ImageZoom
                    image={{
                        src,
                        alt: alt || 'Image',
                    }}
                    defaultStyles={defaultStyles}
                />
            );
        }

        let className = '';
        className += (isExternalPastedImage && !externalUploadedImage) ? 'external-image ' : '';
        className += errorUploading ? 'error-uploading ' : '';
        const showUploadingImageNotice = (isExternalPastedImage || isBase64Image) && !externalUploadedImage && !errorUploading;

        return (
            <Fragment>
                <img
                    className={className}
                    src={src}
                    alt={alt || 'Image'}
                    onLoad={this.handleImageLoaded}
                    onMouseDown={this.handleSelectImage}
                />
                {errorUploading && <div className="error-uploading-text">Error uploading image, please delete and manually insert image</div>}
                {showUploadingImageNotice && <div className="uploading-external-image-text loading">Uploading external image</div>}
            </Fragment>
        );
    }
}

export default withEditorState(Image);
